import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ExerciseHeader = ({ 
  exerciseName, 
  currentSet, 
  totalSets, 
  currentLoad, 
  exerciseType,
  exerciseImage,
  isSuperset = false,
  supersetInfo = null
}) => {
  return (
    <div className="bg-surface rounded-2xl p-8 shadow-lg border border-border mb-6">
      {/* Exercise Image */}
      <div className="flex flex-col lg:flex-row gap-8 items-center">
        <div className="w-full lg:w-1/3">
          <div className="aspect-video bg-muted rounded-xl overflow-hidden">
            <Image
              src={exerciseImage || "https://images.pexels.com/photos/416809/pexels-photo-416809.jpeg"}
              alt={`${exerciseName} demonstration`}
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Exercise Information */}
        <div className="flex-1 text-center lg:text-left">
          {/* Superset Indicator */}
          {isSuperset && supersetInfo && (
            <div className="mb-4">
              <div className="inline-flex items-center bg-secondary/10 text-secondary px-4 py-2 rounded-full">
                <Icon name="Link" size={20} className="mr-2" />
                <span className="text-lg font-semibold">
                  Superset {supersetInfo?.current} of {supersetInfo?.total}
                </span>
              </div>
            </div>
          )}

          {/* Exercise Name */}
          <h1 className="text-4xl lg:text-5xl font-bold text-foreground mb-4">
            {exerciseName}
          </h1>

          {/* Exercise Type */}
          <div className="flex items-center justify-center lg:justify-start mb-6">
            <div className="bg-primary/10 text-primary px-6 py-3 rounded-full">
              <div className="flex items-center space-x-3">
                <Icon 
                  name={exerciseType === 'dynamic' ? 'Activity' : 'Timer'} 
                  size={24} 
                />
                <span className="text-xl font-semibold capitalize">
                  {exerciseType} Exercise
                </span>
              </div>
            </div>
          </div>

          {/* Current Load Information */}
          <div className="bg-accent rounded-xl p-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
              <div>
                <p className="text-lg text-muted-foreground mb-2">Current Load</p>
                <p className="text-3xl font-bold text-foreground">
                  {currentLoad?.weight} {currentLoad?.unit}
                </p>
              </div>
              <div>
                <p className="text-lg text-muted-foreground mb-2">Target Reps</p>
                <p className="text-3xl font-bold text-foreground">
                  {currentLoad?.targetReps}
                </p>
              </div>
              <div>
                <p className="text-lg text-muted-foreground mb-2">Intensity</p>
                <p className="text-3xl font-bold text-primary">
                  Level {currentLoad?.intensity}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Set Progress */}
      <div className="mt-8 pt-6 border-t border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <Icon name="Target" size={32} className="text-primary" />
            <div>
              <p className="text-2xl font-bold text-foreground">
                Set {currentSet} of {totalSets}
              </p>
              <p className="text-lg text-muted-foreground">
                Complete your repetitions
              </p>
            </div>
          </div>

          {/* Progress Bar */}
          <div className="flex-1 max-w-md ml-8">
            <div className="w-full bg-muted rounded-full h-4">
              <div 
                className="bg-primary h-4 rounded-full transition-all duration-500 ease-out"
                style={{ width: `${(currentSet / totalSets) * 100}%` }}
              />
            </div>
            <p className="text-sm text-muted-foreground mt-2 text-center">
              {Math.round((currentSet / totalSets) * 100)}% Complete
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExerciseHeader;